import { useRouter } from 'next/router'
import { Route } from '../../config/router'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model'
import { useIsRedesignedSummaryPage } from '../../utils/convergence'
import { useCachedExperiment } from '..'

export const useInlineArcadeComponentsEnabled = (fireEvent: boolean = true): boolean => {
  const eligibleRoutes = [Route.NEW_PAYMENT_METHOD, Route.EDIT_SHIPPING_ADDRESS, Route.EDIT_SHIPPING_ADDRESS_WITH_ID, Route.NEW_SHIPPING_ADDRESS]
  const router = useRouter()
  const isOnEligibleRoute = eligibleRoutes.includes(router.pathname as Route)
  const isRedesignedSummaryPage = useIsRedesignedSummaryPage()
  const experiment = useCachedExperiment('InlineArcadeComponents', fireEvent)

  const isExperimentActive = experiment.active && !experiment.control
  return isExperimentActive && (isRedesignedSummaryPage || isOnEligibleRoute)
}

type SectionName = 'Inline Payment Method' | 'Inline Address'

export const useGetShowMoreLessHandler = (sectionName: SectionName): ((isNextActionShowMore: boolean) => void) => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const handleShowMoreLess = (isNextActionShowMore: boolean): void => {
    logEvent(TrackingEvent.PRESSED_SUMMARY_SECTION_ACTION, {
      section: sectionName,
      action: isNextActionShowMore ? 'Show More' : 'Show Less',
    })
  }

  return handleShowMoreLess
}
